import { JournalVersion } from "./types";

export const MOCK_JOURNAL_VERSIONS: JournalVersion[] = [
  {
    versionId: "v5",
    versionNumber: 5,
    status: "ACTUAL",
    integrationStatus: "SENT",
    versionDate: "2025-06-07T16:41:00Z",
    responsible: {
      name: "Гендальф Ф. А.",
      role: "Офисный клерк",
    },
  },
  {
    versionId: "v4",
    versionNumber: 4,
    status: "OUTDATED",
    integrationStatus: "ERROR",
    versionDate: "2025-06-07T16:41:00Z",
    responsible: {
      name: "Гендальф Ф. А.",
      role: "Офисный клерк",
    },
  },
  {
    versionId: "v3",
    versionNumber: 3,
    status: "OUTDATED",
    integrationStatus: "ACCEPTED",
    versionDate: "2025-06-09T16:41:00Z",
    responsible: {
      name: "Гендальф Ф. А.",
      role: "Офисный клерк",
    },
  },
  {
    versionId: "v2",
    versionNumber: 2,
    status: "OUTDATED",
    integrationStatus: "REJECTED",
    versionDate: "2025-06-07T16:41:00Z",
    responsible: {
      name: "Гендальф Ф. А.",
      role: "Офисный клерк",
    },
  },
  {
    versionId: "v1",
    versionNumber: 1,
    status: "OUTDATED",
    integrationStatus: null,
    versionDate: "2025-06-07T16:41:00Z",
    responsible: {
      name: "Гендальф Ф. А.",
      role: "Офисный клерк",
    },
  },
];
